/*!
 * voce-config.js
 * Minimal client logic for the VOCE+ product page:
 * - thumb gallery → swap main image
 * - variant picker → update form id, price, line total
 * - qty stepper
 * - tabs
 * - announces cart updates back to Shopify ajax cart drawers if present
 * No framework. ~3.5 kB.
 */
(function () {
  "use strict";

  // ─── Thumbnail gallery ────────────────────────────────────────
  const mainShot = document.getElementById("VoceMainShot");
  if (mainShot) {
    const counter = document.querySelector("[data-voce-shot-counter]");
    const thumbs = document.querySelectorAll("[data-thumb]");
    const total = String(thumbs.length).padStart(2, "0");
    thumbs.forEach((b) => {
      b.addEventListener("click", () => {
        thumbs.forEach((x) => x.classList.remove("is-active"));
        b.classList.add("is-active");
        mainShot.srcset = "";
        mainShot.src = b.dataset.full;
        if (counter) {
          counter.textContent =
            "SHOT " + String(b.dataset.index).padStart(2, "0") + " / " + total;
        }
      });
    });
  }

  // ─── Variant picker ───────────────────────────────────────────
  const productForm = document.querySelector("[data-voce-product-form]");
  if (productForm) {
    const qtyInput = productForm.querySelector("[data-voce-qty-input]");
    const unitPrice = productForm.querySelector("[data-voce-unit-price]");
    const lineTotal = productForm.querySelector("[data-voce-line-total]");
    const atcBtn = productForm.querySelector("[data-voce-atc]");
    const atcLabel = productForm.querySelector("[data-voce-atc-label]");

    const productJson = document.querySelector("[data-voce-product-json]");
    const product = productJson ? JSON.parse(productJson.textContent) : null;

    function formatMoney(cents) {
      const n = cents / 100;
      const fmt = new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: Shopify.currency.active || "USD",
        maximumFractionDigits: 0,
      });
      return fmt.format(n);
    }

    function updateForVariant(variantId) {
      if (!product) return;
      const v = product.variants.find(
        (x) => String(x.id) === String(variantId),
      );
      if (!v) return;
      const qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      if (unitPrice) unitPrice.textContent = formatMoney(v.price);
      if (lineTotal) lineTotal.textContent = formatMoney(v.price * qty);
      if (atcBtn) {
        if (!v.available) {
          atcBtn.disabled = true;
          atcLabel.textContent = "Sold out";
        } else {
          atcBtn.disabled = false;
          atcLabel.textContent =
            qty > 1 ? "Add " + qty + " to cart" : "Add to cart";
        }
      }
      // Highlight selected card
      productForm
        .querySelectorAll(".voce-variant")
        .forEach((c) => c.classList.remove("is-selected"));
      const checked = productForm.querySelector("[data-voce-variant]:checked");
      if (checked)
        checked.closest(".voce-variant").classList.add("is-selected");
      // Update URL ?variant=id without reload
      try {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", v.id);
        window.history.replaceState({}, "", url);
      } catch (e) {}
    }

    productForm.addEventListener("change", (e) => {
      if (e.target.matches("[data-voce-variant]"))
        updateForVariant(e.target.value);
    });

    // Qty steppers
    productForm.querySelectorAll("[data-voce-qty]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const d = parseInt(btn.dataset.voceQty, 10) || 0;
        const next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
        qtyInput.value = next;
        const checked = productForm.querySelector(
          "[data-voce-variant]:checked",
        );
        if (checked) updateForVariant(checked.value);
      });
    });
    qtyInput &&
      qtyInput.addEventListener("input", () => {
        const checked = productForm.querySelector(
          "[data-voce-variant]:checked",
        );
        if (checked) updateForVariant(checked.value);
      });

    // Initial sync
    const initial = productForm.querySelector("[data-voce-variant]:checked");
    if (initial) updateForVariant(initial.value);
  }

  // ─── Tabs ─────────────────────────────────────────────────────
  document.querySelectorAll("[data-voce-tabs]").forEach((tablist) => {
    const tabs = tablist.querySelectorAll("[data-voce-tab]");
    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.forEach((t) => t.setAttribute("aria-selected", "false"));
        tab.setAttribute("aria-selected", "true");
        const targetId = tab.dataset.voceTab;
        document.querySelectorAll(".voce-pdp__tab-panel").forEach((p) => {
          p.hidden = p.id !== targetId;
        });
      });
    });
  });

  // ─── FAQ details: announce open state for analytics ──────────
  document.querySelectorAll(".voce-faq__item").forEach((d) => {
    d.addEventListener("toggle", () => {
      if (d.open && window.dataLayer) {
        window.dataLayer.push({
          event: "faq_open",
          question: d.querySelector(".voce-faq__q span")?.textContent,
        });
      }
    });
  });

  // ─── Cart count refresh after add-to-cart (works alongside Dawn's drawer) ──
  document.addEventListener("submit", (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    // Let normal submission happen unless a drawer intercepts
    setTimeout(() => {
      fetch("/cart.js")
        .then((r) => r.json())
        .then((cart) => {
          document.querySelectorAll("[data-cart-count]").forEach((el) => {
            el.textContent = cart.item_count;
          });
        })
        .catch(() => {});
    }, 600);
  });
})();
